module.exports = __webpack_public_path__ + "static/media/read-message.6c9af1ae.svg";